import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Pill } from '@comparethemarketau/manor-pill';

import { withProductCompareAction } from './with_product_compare_action';

const useStyles = createUseStyles((theme) => ({
    pill: {
        width: `${theme.spacing[104]} !important`,
        height: `${theme.spacing[36]} !important`
    }
}));

const _ComparePill = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { productId, providerCode, isSelected, isDisabled, onCompareClick } = props;

    return (
        <div className={
            classNames('test-policyProductCard-pill')
        }>
            <Pill
                id={`pill-compare-${providerCode}-${productId}`}
                handleClick={onCompareClick}
                selected={isSelected}
                disabled={isDisabled}
                trackingLabel={`Compare product: ${providerCode} - ${productId}`}
                label="Compare"
                clickable={isDisabled}
                className={classNames(classes.pill)}
            />
        </div>
    );
};

_ComparePill.propTypes = {
    productId: PropTypes.string.isRequired,
    providerCode: PropTypes.string,

    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool,

    onCompareClick: PropTypes.func
};

const ComparePill = withProductCompareAction(_ComparePill);

export { ComparePill, _ComparePill };
